import { Component } from '@angular/core';

@Component({
  selector: 'app-trusted',
  imports: [],
  templateUrl: './trusted.component.html',
  styleUrl: './trusted.component.css'
})
export class TrustedComponent {

}
